import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewEncapsulation, inject } from '@angular/core';
import { ISbRichtext } from '@storyblok/js';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { StoryblokComponentInstance } from '../../../services/storyblok.service';
import { RouterLinkDirective } from '../../../shared-extra/directives/route.directive';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLinkDirective,
    BlockWrapperComponent,
    StoryblokRichTextPipe,
    DynamicComponent,
    DynamicIoDirective,
    SafeHtmlPipe,
  ],
})
export class TextComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() style: BlockStyle[];
  @Input() customTextAlign: string;
  @Input() lineHeight: string;

  @Input() content: ISbRichtext;
  @Input() textSize: string;
  @Input() colorOverride: string;
  @Input() alignment: string | boolean = 'center';

  @Input() mobileAlignment: string;
  @Input() tabletAlignment: string;
  @Input() desktopAlignment: string;

  @Input() ulIcons: string;
  @Input() ulIconColor: string;

  contents: (ISbRichtext | { type: 'components'; body: StoryblokComponentInstance[] })[];

  private storyblokService = inject(PICFLOW_STORYBLOK);
  components = this.storyblokService.components;

  ngOnChanges() {
    if (this.alignment === true) this.alignment = 'center';

    this.contents = [];

    let content = {
      type: 'doc',
      content: [],
    };

    this.content.content.forEach(item => {
      if (item.type === 'blok') {
        this.contents.push(content);
        content = {
          type: 'doc',
          content: [],
        };

        item.attrs.body.forEach(blok => {
          if (!('style' in blok)) return;
          if (!blok.style) return;
          if (Array.isArray(blok.style) && !blok.style.length) {
            blok.style = [{} as BlockStyle];
          }
          blok.style[0].inWrapper = true;
        });
        this.contents.push({
          type: 'components',
          body: item.attrs.body,
        });
      } else {
        content.content.push(item);
      }
    });
    this.contents.push(content);
  }

  dynamicInputs(values: { [key: string]: unknown }) {
    return { ...values, inTextComponent: true };
  }
}
